export default {
  appName: "Pay with XEM",
};
